import _NewbieSignaturePad from "./NewbieSignaturePad.jsx";
import withInstall from "../../utils/withInstall";

export const NewbieSignaturePad = withInstall(_NewbieSignaturePad);
export default NewbieSignaturePad;
